<div class="my-5">
  <p-card *ngIf="model">

    <ng-container *ngIf="model.patient as patient">
      <h3 class="main-title mb-3">
        {{ ((patient.firstName || '') + ' ' +(patient.lastName || '')).trim() || patient.email }}
      </h3>
    </ng-container>

    <ng-container *ngIf="model.criticalInfoRecentUpdates as criticalInfoRecentUpdates">
      <ng-container *ngIf="criticalInfoRecentUpdates && criticalInfoRecentUpdates.length">
        <p class="text--md mb-2 pb-1">Care-team summary (critical information)</p>

        <div class="critical-info">
          <ng-container *ngIf="criticalInfoNoAnswer.length">
            <p class="title text--sm mt-3 mb-2">no answer</p>

            <div class="critical-info__item"
                 *ngFor="let item of criticalInfoNoAnswer"
            >
              <div class="d-flex mb-3">
                <div class="icon mr-3"></div>
                <div class="d-flex flex-column">
                  <p class="d-flex align-items-center text--md fw-600">
                    <app-icon
                      [icon]="item.icon"
                      fill="inherit"
                      width="18"
                      height="18"
                    ></app-icon>
                    <span class="pl-2">{{ item.title }}</span>
                  </p>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="criticalInfoAccepted.length">
            <p class="title accepted text--sm mt-3 mb-2">Agree</p>

            <div class="critical-info__item accepted"
                 *ngFor="let item of criticalInfoAccepted"
            >
              <div class="d-flex mb-2">
                <div class="icon mr-3">
                  <app-icon-feather icon="check" fill="inherit" width="12" height="12"></app-icon-feather>
                </div>

                <div class="inner d-flex justify-content-between w-100">
                  <div class="d-flex flex-column mb-2 mr-3">
                    <p class="d-flex align-items-center text--md fw-600">
                      <app-icon
                        [icon]="item.icon"
                        fill="inherit"
                        width="18"
                        height="18"
                      ></app-icon>
                      <span class="pl-2">{{ item.title }}</span>
                    </p>
                    <p class="text--xs text--dark mt-1">{{ item.createdAt | date: ' h:mma M/d/yy' }}</p>
                  </div>

                  <div class="d-flex align-items-center mb-3">
                    <ng-container *ngIf="item.changedBy as changedBy">
                      <div class="mr-2">
                        <p-avatar styleClass="p-avatar--xs" shape="circle" [image]="changedBy.avatar || 'assets/icon/default-user-avatar.svg'"></p-avatar>
                      </div>
                      <p class="changed-by text--dark">{{ ((changedBy.firstName || '') + ' ' +(changedBy.lastName || '')).trim() || changedBy.email }}</p>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="criticalInfoDeclined.length">
            <p class="title declined text--sm mt-3 mb-2">Don’t Agree</p>

            <div class="critical-info__item declined"
                 *ngFor="let item of criticalInfoDeclined"
            >
              <div class="d-flex mb-2">
                <div class="icon mr-3">
                  <app-icon-feather icon="x" fill="inherit" width="12" height="12"></app-icon-feather>
                </div>

                <div class="inner d-flex justify-content-between w-100">
                  <div class="d-flex flex-column mb-2 mr-3">
                    <p class="d-flex align-items-center text--md fw-600">
                      <app-icon
                        [icon]="item.icon"
                        fill="inherit"
                        width="18"
                        height="18"
                      ></app-icon>
                      <span class="pl-1">{{ item.title }}</span>
                    </p>
                    <p class="text--xs text--dark mt-1">{{ item.createdAt | date: ' h:mma M/d/yy' }}</p>
                  </div>

                  <div class="d-flex align-items-center mb-3">
                    <ng-container *ngIf="item.changedBy as changedBy">
                      <div class="mr-2">
                        <p-avatar styleClass="p-avatar--xs" shape="circle" [image]="changedBy.avatar || 'assets/icon/default-user-avatar.svg'"></p-avatar>
                      </div>
                      <p class="changed-by text--dark">{{ ((changedBy.firstName || '') + ' ' +(changedBy.lastName || '')).trim() || changedBy.email }}</p>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="model.healthAgents as healthAgents">
      <ng-container *ngIf="healthAgents && healthAgents.length">
        <p class="text--md mt-4 pt-2">Important contacts</p>
        <div class="mt-3"
             *ngFor="let item of healthAgents"
        >
          <div class="d-flex align-items-center justify-content-between no-select">
            <div class="d-flex">
              <div class="mr-2">
                <p-avatar shape="circle" [image]="item.avatar || 'assets/icon/default-user-avatar.svg'"></p-avatar>
              </div>
              <div class="info">
                <p class="text--sm fw-600">{{ ((item.firstName || '') + ' ' +(item.lastName || '')).trim() || item.email }}</p>
                <p-inputMask
                  readonly="true"
                  [style]="{ border: 'none', padding: 0, fontSize: '14px' }"
                  [ngModel]="item.phoneNumber"
                  mask="+1 (999) 999 9999"
                  slotChar="_"
                ></p-inputMask>
                <p class="text--sm mt-1" style="color: #8C8C8C">{{ item.isNextOfKin ? 'Proxy, Next-of-kin' : 'Proxy' }}</p>
              </div>
            </div>
            <div class="actions d-flex align-items-center gap-15">
              <div class="actions__item ">
                <app-icon icon="phone" fill="#8C8C8C"></app-icon>
              </div>
              <div class="actions__item">
                <app-icon icon="message" fill="#8C8C8C"></app-icon>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
    </ng-container>

  </p-card>
</div>
